export default "__VITE_ASSET__nTQBNcWfpDnpVwUowKDObw__"